export default __webpack_public_path__ + "static/media/profile-folder.4c6ecd8b.svg";